import { ComingSoon as UIComingSoon } from "@jti/ui/components/ComingSoon/ComingSoon";

import { ResponsiveBackgroundImage } from "@/components/HeroBannerContainer/ResponsiveBackgroundImage";
import { usePageConfig } from "@/context/PageConfigContext";

import type { ComingSoonProps } from "./ComingSoon.builder";

export const ComingSoon = ({
  desktopBackgroundImage,
  tabletBackgroundImage,
  mobileBackgroundImage,
  title,
  description,
  subtitle,
  warningBannerText,
  logo,
}: ComingSoonProps) => {
  const { darkMode } = usePageConfig();

  return (
    <UIComingSoon
      desktopBackgroundImage={desktopBackgroundImage}
      title={title}
      description={description}
      subtitle={subtitle}
      logo={logo}
      isDarkMode={darkMode}
      warningBannerText={warningBannerText}
      renderBackgroundImage={() => (
        <ResponsiveBackgroundImage
          desktopImage={desktopBackgroundImage}
          mediumImage={tabletBackgroundImage}
          smallImage={mobileBackgroundImage}
          index={0}
        />
      )}
    />
  );
};
